<script setup lang="ts">
interface Props {
    rounded?: string
    closable?: boolean
}

const props = withDefaults(defineProps<Props>(), {
    rounded: 'lg',
    closable: false
})
</script>

<template>
    <v-alert
        variant="outlined"
        color="blue-lighten-2"
        class="text-body-2 pa-5 bg-blue-lighten-5"
        :rounded="props.rounded"
        :closable="props.closable"
        role="alert"
    >
        <div class="text-black">
            <slot />
        </div>
    </v-alert>
</template>

<style scoped>

</style>
